import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import Async from 'react-select/lib/Async';

import api from 'core/utils/api';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  property: PropTypes.object,
};

const mapProps = (property) => {
  const { id, address, client: { first_name, last_name } } = property;
  const { street, street2, city, zip_code, state: { postal_code, id: stateId } } = address;
  let key = street;
  if (street2) { key += ` ${street}`; }
  key += ` ${city}, ${postal_code} ${zip_code} (${first_name} ${last_name})`;
  return {
    id,
    name: key,
    stateId,
  };
};

class PropertyLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.loadProperties = debounce(this.loadProperties, 300).bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const { property } = this.props;
    if (property) { this.handleChange(mapProps(property)); }
  }

  handleBlur() {
    const { onBlur } = this.props;
    if (onBlur) { onBlur(); }
  }

  handleChange(property) {
    this.setState({ property }, () => this.props.onChange(property));
  }

  loadProperties(inputValue, callback) {
    this.setState({ loading: true }, () => {
      api
        .get('/properties', { params: { address: inputValue.toLowerCase() } })
        .then((res) => {
          this.setState({ loading: false });
          callback(res.data.properties.map(property => mapProps(property)));
        });
    });
  }

  render() {
    const { loading } = this.state;

    return (
      <Async
        name="propertyLookup"
        value={this.state.property}
        isLoading={loading}
        isClearable
        onChange={this.handleChange}
        loadOptions={this.loadProperties}
        onBlur={this.handleBlur}
        getOptionLabel={option => option.name}
        getOptionValue={option => option.id}
      />
    );
  }
}

PropertyLookup.propTypes = propTypes;

export default PropertyLookup;



// WEBPACK FOOTER //
// ./src/components/PropertyLookup.js